import { gql } from '@apollo/client';

export const CREATE_STREAM = gql`
  mutation CreateStream($input: CreateStreamInput!) {
    createStream(input: $input) {
      stream {
        id
        name
        isActive
        streamLeadId
        deliveryManagerId
        streamLead {
          id
          firstName
          lastName
        }
        deliveryManager {
          id
          firstName
          lastName
        }
        createdAt
      }
      message
    }
  }
`;

export const UPDATE_STREAM = gql`
  mutation UpdateStream($where: StreamWhereInput!, $input: UpdateStreamInput!) {
    updateStream(where: $where, input: $input) {
      stream {
        id
        name
        isActive
        streamLeadId
        deliveryManagerId
        streamLead {
          id
          firstName
          lastName
        }
        deliveryManager {
          id
          firstName
          lastName
        }
        updatedAt
      }
      message
    }
  }
`;
